import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-lead-message-list',
  templateUrl: './lead-message-list.component.html',
  styleUrls: ['./lead-message-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None
})
export class LeadMessageListComponent implements OnInit {

  filterValue: string = 'Lead Message List';
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  columns: any[] = [
    { name: 'Name', property: 'pageName', visible: true },
    { name: 'Actions', property: 'actions', visible: true }
  ];
  elementData: any[] = [
    {pageName: 'Covered', value: 'covered'},
    {pageName: 'Not Covered', value: 'not-covered'},
  ];
  constructor(private api: ApiService, private cdr: ChangeDetectorRef, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.elementData);
  }
  onFilterChange(value: any) {
    if (!this.dataSource) {return}
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  };
  
}
